/* Product custom blocks - extracted for editor performance */

/* Trust section scroll trigger */
(function() {
  var trigger = document.querySelector('.trust-scroll-trigger');
  if (!trigger) return;
  trigger.addEventListener('click', function() {
    var target =
      document.getElementById('shopify-section-template--27449932480843__ss_testimonials_38_UV4Jpt') ||
      document.querySelector('[id*="ss_testimonials_38"]');
    if (!target) return;
    var rect = target.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var offset = rect.top + window.pageYOffset - (viewportHeight - rect.height) / 2;
    window.scrollTo({ top: offset, behavior: 'smooth' });
  });
})();

/* Ship cutoff countdown: before the daily cutoff on a shipping day, show
   "Order within HH:MM:SS, ships Monday"; otherwise show the next shipping weekday.
   Replaces the static "Ships by X" text in the inline-status block. */
(function(){
  var el = document.getElementById('shipDate');
  if(!el) return;
  var wrap = el.parentElement || el; /* the "Ships by <span id=shipDate>" span */
  var CUTOFF_HOUR = 11; /* Europe/Amsterdam daily shipping cutoff */
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function amsNow(){
    var now = new Date();
    var p = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false, weekday: 'short'
    }).formatToParts(now).reduce(function(o, x){ o[x.type] = x.value; return o; }, {});
    return { y: +p.year, m: +p.month - 1, d: +p.day, h: (+p.hour) % 24, mi: +p.minute, s: +p.second, wd: p.weekday };
  }
  function nextShipDate(t){
    var ship = new Date(Date.UTC(t.y, t.m, t.d));
    if (t.h >= CUTOFF_HOUR) {
      if (t.wd === 'Sat') ship.setUTCDate(ship.getUTCDate() + 2); else ship.setUTCDate(ship.getUTCDate() + 1);
    }
    var swd = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Amsterdam', weekday: 'short' }).format(ship);
    if (swd === 'Sun') ship.setUTCDate(ship.getUTCDate() + 1);
    return new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Amsterdam', month: 'short', day: 'numeric' }).format(ship);
  }
  var TRUCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" style="display:block"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9L21.46 12H17V9.5h2.5zM18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>';
  function ensureIcon(){
    var right = wrap.parentElement; if (!right) return;
    /* Drop "Only few items left" and left-align the ship line. */
    right.style.marginLeft = '0'; /* was margin-left:auto (pushed right) */
    var status = right.closest('.inline-status');
    if (status) { status.style.justifyContent = 'flex-start'; var lft = status.querySelector('.status-left'); if (lft) lft.style.display = 'none'; }
    if (right.querySelector('.bj-ship-ico')) return;
    var dot = right.querySelector('.dot'); if (dot) dot.style.display = 'none';
    var ico = document.createElement('span');
    ico.className = 'bj-ship-ico';
    ico.setAttribute('aria-hidden', 'true');
    ico.style.cssText = 'display:inline-flex;align-items:center;margin-right:6px;flex:0 0 auto';
    ico.innerHTML = TRUCK;
    right.insertBefore(ico, wrap);
  }
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var FULL = { Sun: 'Sunday', Mon: 'Monday', Tue: 'Tuesday', Wed: 'Wednesday', Thu: 'Thursday', Fri: 'Friday', Sat: 'Saturday' };
  /* Seconds until the next shipping cutoff (CUTOFF_HOUR on a ship day, Mon-Sat),
     plus which ship day that cutoff belongs to. */
  function nextCutoff(t){
    var sod = CUTOFF_HOUR * 3600;
    var nowSec = t.h * 3600 + t.mi * 60 + t.s;
    var idx = DAYS.indexOf(t.wd);
    for (var i = 0; i < 8; i++) {
      var wd = DAYS[(idx + i) % 7];
      if (wd === 'Sun') continue; /* no Sunday shipping */
      if (i === 0) { if (nowSec < sod) return { secs: sod - nowSec, off: 0, wd: wd }; }
      else return { secs: i * 86400 - nowSec + sod, off: i, wd: wd };
    }
    return null;
  }
  /* Verzenddag in woorden (Pim 07-09-2026): de verzenddatum is een Amsterdamse
     kalenderdag; valt die op de LOKALE "vandaag" van de bezoeker dan "today", op zijn
     lokale "morgen" dan "tomorrow", anders de dagnaam (bv. zaterdag na de cutoff:
     "Monday"). Zo klopt het ook voor een bezoeker in Los Angeles of Tokio. */
  function ymdUTC(d){ return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function shipWord(nc, t){
    try {
      var ship = new Date(Date.UTC(t.y, t.m, t.d + nc.off));
      var now = new Date();
      var today = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
      var tomorrow = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() + 1));
      var s = ymdUTC(ship);
      if (s === ymdUTC(today)) return 'today';
      if (s === ymdUTC(tomorrow)) return 'tomorrow';
    } catch (e) {}
    return FULL[nc.wd];
  }
  /* Gratis verzending in de regel (Pim 07-09-2026): haalt de losse prijs van de gekozen
     variant, in de valuta van de bezoeker, de drempel van zijn markt? Dan staat er
     "ships free Monday" in plaats van "ships Monday". De data komt uit
     <script type="application/json" data-bj-freeship> in sections/main-product.liquid
     (drempel via snippets/bj-freeship-threshold, dezelfde bron als de winkelwagen). */
  var FS;
  function fsData(){
    if (FS !== undefined) return FS;
    FS = null;
    try {
      var node = document.querySelector('script[data-bj-freeship]');
      if (node) { var d = JSON.parse(node.textContent || '{}'); if (d && d.prices) FS = d; }
    } catch (e) {}
    return FS;
  }
  function currentVariantId(){
    var inp = document.querySelector('product-form form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (inp && inp.value) return String(inp.value);
    try { var v = new URLSearchParams(window.location.search).get('variant'); if (v) return String(v); } catch (e) {}
    return '';
  }
  function shipsFree(){
    var d = fsData();
    if (!d || !(Number(d.threshold) > 0)) return false;
    var price = d.prices[currentVariantId()];
    if (price == null) price = d.prices[String(d.selected)];
    if (price == null) return false;
    var pct = Number(d.discountPercent) || 0;
    if (pct > 0) price = price - Math.floor(price * pct / 100); /* zelfde afkap als de PDP-prijs */
    return price >= Number(d.threshold);
  }
  function freeWord(){ return shipsFree() ? '<span data-bj-ship-free>free</span> ' : ''; }
  function setLabel(label, html){ if (label.getAttribute('data-bj-ship-html') !== html) { label.innerHTML = html; label.setAttribute('data-bj-ship-html', html); } }
  function ensureParts(){
    ensureIcon();
    wrap.style.display = 'inline-flex';
    wrap.style.alignItems = 'center';
    wrap.style.whiteSpace = 'nowrap';
    wrap.style.gap = '0';
    wrap.setAttribute('aria-live', 'polite');
    var timer = wrap.querySelector('[data-bj-ship-timer]');
    var label = wrap.querySelector('[data-bj-ship-label]');
    if (!timer || !label) {
      wrap.textContent = '';
      timer = document.createElement('span');
      timer.setAttribute('data-bj-ship-timer', '');
      timer.style.cssText = 'display:inline-block;flex:0 0 auto;width:auto;min-width:0;font-variant-numeric:tabular-nums;text-align:left;white-space:nowrap;';
      label = document.createElement('span');
      label.setAttribute('data-bj-ship-label', '');
      label.style.cssText = 'display:inline-block;flex:0 0 auto;white-space:nowrap;margin-left:8px;';
      wrap.appendChild(timer);
      wrap.appendChild(label);
    }
    return { timer: timer, label: label };
  }
  function render(){
    var parts = ensureParts();
    var t = amsNow();
    var nc = nextCutoff(t);
    /* display:none i.p.v. visibility:hidden: een verborgen timer mag geen
       116px witruimte laten staan tussen het truck-icoon en "Ships ...". */
    if (!nc) {
      parts.timer.style.display = 'none';
      parts.timer.textContent = 'Order in 00:00:00,';
      parts.label.style.marginLeft = '0'; /* zonder timer strak naast het truck-icoon */
      setLabel(parts.label, 'Ships ' + freeWord() + nextShipDate(t));
      return;
    }
    var when = shipWord(nc, t);
    if (nc.off === 0) {
      var s = nc.secs;
      parts.timer.style.display = '';
      parts.timer.style.visibility = 'visible';
      /* De klok in een eigen span, zodat een template alleen de tijd kan vetten. */
      parts.timer.innerHTML = 'Order within <span data-bj-ship-clock>' + pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60) + '</span>,&nbsp;';
      parts.label.style.marginLeft = '0';
      setLabel(parts.label, 'ships ' + freeWord() + when);
    } else {
      parts.timer.style.display = 'none';
      parts.timer.textContent = 'Order in 00:00:00,';
      parts.label.style.marginLeft = '0'; /* zonder timer strak naast het truck-icoon */
      setLabel(parts.label, 'Order now, ships ' + freeWord() + when);
    }
  }
  render();
  setInterval(render, 1000);
})();

/* Lucide icons init */
if (typeof lucide !== 'undefined') { lucide.createIcons(); }


/* BJ_ROPE_BUNDLE_ONE_COLOR_SANITIZER_V1
   Safeguard for cached/search-param Rope Bundle PDP HTML: force one visible Color selector,
   sync hidden Rope Chain color, and use fixed flat silver/gold swatches. */
(function(){
  var SILVER_COLOR = 'linear-gradient(90deg,#9a9a9a 0%,#eeeeee 22%,#ffffff 45%,#cfcfcf 68%,#777777 100%)';
  var GOLD_COLOR = 'linear-gradient(90deg,#8f6418 0%,#f5d779 20%,#fff4aa 44%,#c99127 72%,#7f5512 100%)';
  function text(el){ return (el && el.textContent || '').replace(/\s+/g,' ').trim(); }
  function isRopeBundle(){
    if (location.pathname.indexOf('/products/billie-rope-bundle') !== -1) return true;
    var p = document.querySelector('script[data-product-json]');
    return !!(p && p.textContent.indexOf('"handle":"billie-rope-bundle"') !== -1);
  }
  function setSwatch(label, color){
    if (!label) return;
    var span = label.querySelector('.swatch') || label;
    var bg = color === 'gold' ? GOLD_COLOR : SILVER_COLOR;
    label.setAttribute('data-bj-color', color);
    label.style.setProperty('--bj-swatch-bg', bg);
    label.style.setProperty('background', bg, 'important'); label.style.setProperty('background-size', 'cover', 'important'); label.style.setProperty('background-position', 'center', 'important'); label.style.setProperty('background-size', 'cover', 'important'); label.style.setProperty('background-position', 'center', 'important');
    if (span) {
      span.style.setProperty('--swatch--background', bg);
      span.style.setProperty('--bj-swatch-bg', bg);
      span.style.setProperty('background', bg, 'important'); span.style.setProperty('background-size', 'cover', 'important'); span.style.setProperty('background-position', 'center', 'important'); span.style.setProperty('animation', 'none', 'important'); span.style.setProperty('background-size', 'cover', 'important'); span.style.setProperty('background-position', 'center', 'important'); span.style.setProperty('animation', 'none', 'important');
    }
  }
  function normalize(){
    if (!isRopeBundle()) return;
    var pickers = document.querySelectorAll('variant-selects');
    pickers.forEach(function(picker){
      var fields = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
      var ropeFields = fields.filter(function(fs){
        var legend = text(fs.querySelector('legend'));
        return /Rope Bracelet|Rope Chain|^Color:/.test(legend) && fs.querySelector('input[type="radio"][value*="Plated"]');
      });
      if (!ropeFields.length) return;
      var visible = ropeFields[0];
      var hidden = ropeFields[1] || null;
      picker.classList.add('bj-rope-bundle-picker');
      visible.classList.add('bj-bundle-picker');
      visible.setAttribute('data-bj-rope-color-option','visible');
      var legend = visible.querySelector('legend');
      if (legend) {
        var checked = visible.querySelector('input[type="radio"]:checked');
        var selected = checked && /gold/i.test(checked.value) ? 'Gold' : 'Silver';
        legend.innerHTML = 'Color: <span data-selected-value>' + selected + '</span>';
      }
      Array.prototype.slice.call(visible.querySelectorAll('input[type="radio"]')).forEach(function(input){
        var color = /gold/i.test(input.value) ? 'gold' : 'silver';
        input.setAttribute('data-bj-rope-color-value', color);
        var label = visible.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        if (label) { label.title = color === 'gold' ? 'Gold' : 'Silver'; setSwatch(label, color); }
      });
      if (hidden) {
        hidden.classList.add('bj-rope-bundle-hidden-color');
        hidden.setAttribute('data-bj-rope-color-option','hidden');
        hidden.style.setProperty('display','none','important');
        hidden.style.setProperty('visibility','hidden','important');
        hidden.style.setProperty('height','0','important');
        hidden.style.setProperty('margin','0','important');
        hidden.style.setProperty('overflow','hidden','important');
      }
      function sync(){
        var checked = visible.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        var gold = /gold/i.test(checked.value);
        var selected = visible.querySelector('legend [data-selected-value]');
        if (selected) selected.textContent = gold ? 'Gold' : 'Silver';
        if (hidden) {
          var target = Array.prototype.slice.call(hidden.querySelectorAll('input[type="radio"]')).find(function(i){ return gold ? /gold/i.test(i.value) : /silver/i.test(i.value); });
          if (target && !target.checked) { target.checked = true; target.dispatchEvent(new Event('change', {bubbles:true})); }
        }
      }
      if (!visible.__bjRopeOneColorBound) {
        visible.__bjRopeOneColorBound = true;
        visible.addEventListener('change', function(){ setTimeout(sync, 0); });
      }
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalize); else normalize();
  window.addEventListener('load', normalize);
  setTimeout(normalize, 250);
  setTimeout(normalize, 1000);
})();


/* BJ_JEWELRY_STATIC_GRADIENT_SWATCHES_V1
   All Billie Jewelry color swatches are static gradient blocks, not product/media thumbnails. */
(function(){
  var SILVER_COLOR = 'linear-gradient(90deg,#9a9a9a 0%,#eeeeee 22%,#ffffff 45%,#cfcfcf 68%,#777777 100%)';
  var GOLD_COLOR = 'linear-gradient(90deg,#8f6418 0%,#f5d779 20%,#fff4aa 44%,#c99127 72%,#7f5512 100%)';
  function isJewelryPage(){
    var handle = (location.pathname.match(/\/products\/([^/?#]+)/)||[])[1] || '';
    if (/jeans-pins|waist-knot/i.test(handle)) return false;
    return /rope|tennis|spring|jewelry|bracelet|chain|bundle/i.test(handle);
  }
  function injectCss(){
    if (document.getElementById('bj-jewelry-gradient-swatches-v1')) return;
    var style = document.createElement('style');
    style.id = 'bj-jewelry-gradient-swatches-v1';
    style.textContent = [
      'variant-selects .bj-bundle-picker input[type="radio"]+label{position:relative!important;background-size:cover!important;background-position:center!important;overflow:hidden!important}',
      'variant-selects .bj-bundle-picker input[type="radio"]+label .swatch{background:var(--bj-swatch-bg,var(--swatch--background))!important;background-size:cover!important;background-position:center!important;animation:none!important}',
      'variant-selects .bj-bundle-picker input[type="radio"]+label[data-bj-color="silver"] .swatch{background:'+SILVER_COLOR+'!important}',
      'variant-selects .bj-bundle-picker input[type="radio"]+label[data-bj-color="gold"] .swatch{background:'+GOLD_COLOR+'!important}',
      'variant-selects .bj-bundle-picker input[type="radio"]:checked+label .swatch{border:0.1rem solid rgba(18,18,18,.15)!important;box-shadow:none!important}'
    ].join('\n');
    document.head.appendChild(style);
  }
  function apply(){
    if (!isJewelryPage()) return;
    injectCss();
    document.querySelectorAll('variant-selects fieldset').forEach(function(fs){
      var hasColor = false;
      fs.querySelectorAll('input[type="radio"]').forEach(function(input){
        if (/silver|gold|plated/i.test(input.value || '')) hasColor = true;
      });
      var legend = (fs.querySelector('legend') && fs.querySelector('legend').textContent || '');
      if (!hasColor || !/color|bracelet|chain/i.test(legend)) return;
      fs.classList.add('bj-bundle-picker');
      fs.querySelectorAll('input[type="radio"]').forEach(function(input){
        var color = /gold/i.test(input.value || '') ? 'gold' : 'silver';
        var label = input.id ? fs.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
        if (!label) return;
        var bg = color === 'gold' ? GOLD_COLOR : SILVER_COLOR;
        label.setAttribute('data-bj-color', color);
        label.style.setProperty('--bj-swatch-bg', bg);
        var swatch = label.querySelector('.swatch') || label;
        swatch.style.setProperty('--swatch--background', bg);
        swatch.style.setProperty('--bj-swatch-bg', bg);
        swatch.style.setProperty('background', bg, 'important'); swatch.style.setProperty('background-size', 'cover', 'important'); swatch.style.setProperty('background-position', 'center', 'important'); swatch.style.setProperty('animation', 'none', 'important');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', apply);
  setTimeout(apply, 250);
  setTimeout(apply, 1000);
})();

(function(){
  var silver='linear-gradient(90deg,#9a9a9a 0%,#eeeeee 22%,#ffffff 45%,#cfcfcf 68%,#777777 100%)';
  var gold='linear-gradient(90deg,#8f6418 0%,#f5d779 20%,#fff4aa 44%,#c99127 72%,#7f5512 100%)';
  function isBjJewelryMaterialPage(){
    if (document.body && document.body.classList && document.body.classList.contains('template-product-billie-jewelry')) return true;
    var handle = (location.pathname.match(/\/products\/([^/?#]+)/)||[])[1] || '';
    return /rope|tennis|spring|bracelet|chain|jewelry/i.test(handle) && !/jeans-pins|waist-knot/i.test(handle);
  }
  function applyBjJewelryMaterialSwatches(){
    if (!isBjJewelryMaterialPage()) return;
    document.querySelectorAll('variant-selects .bj-bundle-picker .swatch-input__label--square, variant-selects .bj-jewelry-material-swatch .swatch-input__label--square').forEach(function(label){
      var raw=((label.getAttribute('data-bj-color')||label.title||label.textContent||'')+'').toLowerCase();
      var bg=raw.indexOf('gold')>-1?gold:silver;
      label.style.setProperty('--bj-swatch-bg',bg);
      label.style.setProperty('background',bg,'important');
      label.style.setProperty('box-shadow','none','important');
      label.style.setProperty('outline','none','important');
      var input=label.htmlFor&&document.getElementById(label.htmlFor);
      label.style.setProperty('border',input&&input.checked?'1px solid rgb(17,17,17)':'1px solid rgba(18,18,18,.18)','important');
      var sw=label.querySelector('.swatch');
      if(sw){
        sw.style.setProperty('--bj-swatch-bg',bg);
        sw.style.setProperty('background-image', bg, 'important'); sw.style.setProperty('background',bg,'important'); sw.style.setProperty('background-size','cover','important'); sw.style.setProperty('background-position','center','important'); sw.style.setProperty('animation','none','important');
        sw.style.setProperty('border','0','important');
        sw.style.setProperty('box-shadow','none','important');
        sw.style.setProperty('outline','none','important');
        sw.style.setProperty('width','100%','important');
        sw.style.setProperty('height','100%','important');
      }
    });
  }
  function scheduleBjJewelryMaterialSwatches(){
    applyBjJewelryMaterialSwatches();
    requestAnimationFrame(applyBjJewelryMaterialSwatches);
    setTimeout(applyBjJewelryMaterialSwatches,0);
    setTimeout(applyBjJewelryMaterialSwatches,80);
    setTimeout(applyBjJewelryMaterialSwatches,250);
    setTimeout(applyBjJewelryMaterialSwatches,750);
  }
  document.addEventListener('click',function(e){ if(e.target && e.target.closest && e.target.closest('variant-selects .bj-bundle-picker')) scheduleBjJewelryMaterialSwatches(); },true);
  document.addEventListener('change',scheduleBjJewelryMaterialSwatches,true);
  document.addEventListener('variant:change',scheduleBjJewelryMaterialSwatches,true);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scheduleBjJewelryMaterialSwatches); else scheduleBjJewelryMaterialSwatches();
  setTimeout(scheduleBjJewelryMaterialSwatches,250); setTimeout(scheduleBjJewelryMaterialSwatches,1200);
})();

/* bj jewelry single-source shine cache-bust 1777558345 */

/* bj jewelry static metal gradient swatches cache-bust 1777558520 */

/* bj jewelry static non-moving gradient swatches cache-bust 1777558917 */
